/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Oslernfoerderung4Inputs */

const de__field_oslernfoerderung4 = /** @type {(inputs: _Field_Oslernfoerderung4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS-Schüler:innen pro Lerförderung`)
};

/**

* @param {_Field_Oslernfoerderung4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_oslernfoerderung4 = /** @type {((inputs?: _Field_Oslernfoerderung4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Oslernfoerderung4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_oslernfoerderung4(inputs)
});
export { _field_oslernfoerderung4 as "_field_OSLernFoerderung" }